module.exports = __webpack_public_path__ + "static/media/PinUpYellow.7f1c9444.svg";